import { render, staticRenderFns } from "./DSPView.vue?vue&type=template&id=5c70eb45"
import script from "./DSPView.vue?vue&type=script&lang=js"
export * from "./DSPView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports